/* eslint-disable require-jsdoc */
import { StateListenerRegistry } from '../base/redux';


function meetWithOutBoundCall({ getState }) {
    const state = getState();
    const { conference, room } = state['features/base/conference'];

    if (conference) {
        const phoneNumber = sessionStorage.getItem(`room=${room}`);

        if (phoneNumber) {

            conference.dial(`${phoneNumber}`);
            sessionStorage.removeItem(`room=${room}`);
        }
    }

}
StateListenerRegistry.register(
    state => state['features/base/conference'].conference,
    (conference, store) => {
        meetWithOutBoundCall(store);
    }
);
